<template>
  <v-container>
    <v-dialog v-model="dialogStockReports" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <template>
          <v-toolbar class="primary white--text">
            <v-toolbar-title>
              STOCK REPORTS
            </v-toolbar-title> 
            <v-spacer></v-spacer>
              <v-text-field  
                solo
                outlined 
                :autofocus="true"
                class="product-report-search"
                clearable 
                label="Search Product" 
                @keyup.native="keymonitor($event)" />
            <v-spacer></v-spacer>
            <v-btn icon>
              <v-icon class="white--text"  @click="printStockReports()">print</v-icon>
            </v-btn>
            <v-btn icon dark @click="dialogStockReports = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <div style="padding: 15px 20px 0px 20px" v-if="Object.keys(filters).length">
            Active Filters:
            <v-row justify="center" align="center">
              <v-chip v-if="filters.date.model" :ripple="false">From Date : {{new Date(filters.date.model).toLocaleDateString('en-GB')}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.tillDate.model" :ripple="false">Till Date : {{new Date(filters.tillDate.model).toLocaleDateString('en-GB')}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.month.model" :ripple="false">Month : {{filters.month.model+1}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.duration.model" :ripple="false">Duration : {{filters.duration.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.firms.model" :ripple="false">Firm : {{getFirmName(filters.firms.model)}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.gstType.model" :ripple="false">GST Type : {{filters.gstType.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.paymentType.model" :ripple="false">Payment Type : {{filters.paymentType.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.status && filters.status.model" :ripple="false">Status : {{filters.status.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.invoiceNumber.model" :ripple="false">Invoice Number : {{filters.invoiceNumber.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.buyerName.model" :ripple="false">Buyer Name : {{filters.buyerName.model}}</v-chip>
            </v-row>
              <v-row justify="center" align="center">
              <v-chip v-if="filters.gstPercentage.model" :ripple="false">GST Percentage : {{filters.gstPercentage.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.gstCategory.model" :ripple="false">GST Category : {{filters.gstCategory.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.isActive.model" :ripple="false">Product Status : {{filters.isActive.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.hsnCode.model" :ripple="false">HSN : {{filters.hsnCode.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.unit.model" :ripple="false">UNIT : {{filters.unit.model}}</v-chip>
            </v-row>
            <v-row justify="center" align="center">
              <v-chip v-if="filters.quantity.model" :ripple="false">Quantity : {{filters.quantity.model}}</v-chip>
            </v-row>
        </div>
          <v-card-text>
            <v-data-table
              :headers="productListHeader"
              :items="filters.stockReportType.model == 'quantity' ? filteredProduct : filteredProductByWeight"
              hide-actions
              class="elevation-1 dashboardHead  stocks-reports"
              v-if="reportType == 'stock'"
            >
    <template slot="headers" slot-scope="props">
  <tr>
    <th>Sr
    </th>
    <th>Action</th>
    <!-- <th>Name, Description, HSN, GST type, Rate, Unit</th> -->
    <th>
      <span style="font-size: 20px;">NAME - Description</span>
      <!-- <br>
      <span>HSN-GST-RATE-UNIT</span> -->
    </th>
    <th>
      <span style="font-size: 20px;">Opening Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <span style="font-size: 20px;">Purchase Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>

    <th>
      <span style="font-size: 20px;">Sales Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <!-- <span style="font-size: 20px;">Closing Stock</span> -->
      <v-select
          style="margin-bottom: -35px;"
          :items="stockReportTypes"
          label="Closing Stock"
          v-model="selectedClosingStockType"
        ></v-select>
      <br>
      <span style="float: left;">Quantity</span>
      <span style="float: right;">Amount</span>
    </th>
  </tr>
</template>
      <template slot="items" slot-scope="props">
      <tr>
        <td style="text-align : center">
          <!-- <v-icon v-if="props.item['name'] != 'Total'" @click="openProdInvoice(props.item)" color="primary">remove_red_eye</v-icon> -->
          <b v-if="props.item['name'] != 'Total'">{{props.index + 1}}</b>
        </td>
        <td style="text-align : center">
          <v-icon v-if="props.item['name'] != 'Total'" @click="openProdItems(props.item)" color="primary">remove_red_eye</v-icon>
        </td>
        <td>
          <b>{{ props.item['name']}}</b>
        <td>
          <span style="float: left;"><b class="font-weight-bold info--text" :title="props.item['openingQuantityTitle']">{{ props.item['openingQuantity']}}</b></span>
          <span style="float: right;"><b >{{ props.item['openingBalance'] || 0 | amount }}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold primary--text" :title="props.item['purchaseQuantityTitle']">{{ props.item['durationQtyPurchase']}}</b></span>
          <span style="float: right;"><b> {{ props.item['durationAmountPurchase'] || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold green--text" :title="props.item['saleQuantityTitle']">{{ props.item['durationQtySale']}}</b></span>
          <span style="float: right;"><b> {{ props.item['durationAmountSale'] || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold red--text" :title="props.item['closingQuantityTitle']">{{ props.item['closingQuantity']}}</b></span>
          <span style="float: right;"><b> {{props.item['closingAmount']|| 0 | amount}}</b></span>
        </td>
      </tr>
      </template>
      <template slot="no-data">No Items</template>
    </v-data-table>
                <v-data-table
              :headers="productListHeader"
              :items="filteredGroups"
              hide-actions
              class="elevation-1 dashboardHead  stocks-reports"
              v-if="reportType == 'productGroup'"
            >
    <template slot="headers" slot-scope="props">
  <tr>
    <th>Sr
    </th>
    <th>Action</th>
    <th>
      <span style="font-size: 20px;">NAME - Description</span>
    </th>
    <th>
      <span style="font-size: 20px;">Opening Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <span style="font-size: 20px;">Purchase Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>

    <th>
      <span style="font-size: 20px;">Sales Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <!-- <span style="font-size: 20px;">Closing Stock</span> -->
      <!-- <v-select
          style="margin-bottom: -35px;"
          :items="stockReportTypes"
          label="Closing Stock"
          v-model="selectedClosingStockType"
        ></v-select> -->
         <span style="font-size: 20px;">Closing Stock</span>
      <br>
      <span style="float: left;">Quantity</span>
      <span style="float: right;">Amount</span>
    </th>
  </tr>
</template>
      <template slot="items" slot-scope="props">
      <tr>
        <td style="text-align : center">
          <b v-if="props.item['name'] != 'Total'">{{props.index + 1}}</b>
        </td>
        <td style="text-align : center">
          <v-icon v-if="props.item['name'] != 'Total'" @click="openProdItems(props.item)" color="primary">remove_red_eye</v-icon>
        </td>
        <td>
          <b>{{ props.item['name']}}</b>
        <td>
          <span style="float: left;"><b class="font-weight-bold info--text" :title="props.item['openingQuantityTitle']">{{ props.item['openingQuantity']}}</b></span>
          <span style="float: right;"><b >{{ props.item['openingBalance'] || 0 | amount }}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold primary--text" :title="props.item['purchaseQuantityTitle']">{{ props.item['durationQtyPurchase']}}</b></span>
          <span style="float: right;"><b> {{ props.item['durationAmountPurchase'] || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold green--text" :title="props.item['saleQuantityTitle']">{{ props.item['durationQtySale']}}</b></span>
          <span style="float: right;"><b> {{ props.item['durationAmountSale'] || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold red--text" :title="props.item['closingQuantityTitle']">{{ props.item['closingQuantity']}}</b></span>
          <span style="float: right;"><b> {{props.item['closingAmount']|| 0 | amount}}</b></span>
        </td>
      </tr>
      </template>
      <template slot="no-data">No Items</template>
    </v-data-table>
  </v-card-text>
    </template>      
      </v-card>
    </v-dialog> 
    <v-data-table
      :headers="productListHeader"
      :items="filters.stockReportType.model == 'quantity' ? filteredProduct : filteredProductByWeight"
      hide-actions
      class="elevation-1 dashboardHead"
      v-if="reportType == 'stock'"
    >
    <template slot="headers" slot-scope="props">
  <tr>
    <th>
      <v-btn flat icon class="full-screen-view" @click="dialogStockReports = true">
        <v-icon>menu</v-icon>
      </v-btn>
    </th>
    <th>
      <span style="font-size: 20px;">Name - Description</span>
      <br>
      <span>HSN-GST-RATE-UNIT</span>
    </th>
    <th>
      <span style="font-size: 20px;">Opening Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <span style="font-size: 20px;">Purchase Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <span style="font-size: 20px;">Sales Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
       <v-select
          style="margin-bottom: -35px;"
          :items="stockReportTypes"
          label="Closing Stock"
          v-model="selectedClosingStockType"
        ></v-select>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
  </tr>
</template>
      <template slot="items" slot-scope="props">
        <td style="text-align : center">
          <b v-if="props.item['name'] != 'Total'">{{props.index + 1}}</b>
        </td>
        <td>
          <b>{{ props.item['name']}}</b>
        
        <template v-if="props.item['description']">
          <br/>Desc : {{ props.item['description']}}
        </template>
         <template v-if="props.item['HSN_code']">
          <br/>HSN : {{ props.item['HSN_code']}}
        </template>
        <template v-if="props.item['GST_type']">
          GST Category : {{ props.item['GST_type']}}
        </template>
        <template v-if="props.item['taxableGST_rate']">
          <br/>
          Rate : {{ props.item['taxableGST_rate']}}
        </template>
        <template v-if="props.item['unit']">
          Unit : {{ props.item['unit']}}
        </template>
        </td>
         <td>
          <span style="float: left;"><b class="font-weight-bold info--text" :title="props.item['openingQuantityTitle']">{{ props.item['openingQuantity']}}</b></span>
          <span style="float: right;"><b >{{ props.item['openingBalance'] || 0 | amount }}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold primary--text" :title="props.item['purchaseQuantityTitle']">{{ props.item['durationQtyPurchase']}}</b></span>
          <span style="float: right;"><b> {{ props.item['durationAmountPurchase'] || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold green--text" :title="props.item['saleQuantityTitle']">{{ props.item['durationQtySale']}}</b></span>
          <span style="float: right;"><b> {{ props.item['durationAmountSale'] || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold red--text" :title="props.item['closingQuantityTitle']">{{ props.item['closingQuantity']}}</b></span>
          <span style="float: right;"><b>{{props.item['closingAmount']|| 0 | amount}}</b></span>
        </td>
      </template>
      <template slot="no-data">No Items</template>
    </v-data-table>
        <v-data-table
      :headers="productListHeader"
      :items="filteredGroups"
      hide-actions
      class="elevation-1 dashboardHead"
      v-if="reportType == 'productGroup'"
    >
    <template slot="headers" slot-scope="props">
  <tr>
    <th>
      <v-btn flat icon class="full-screen-view" @click="dialogStockReports = true">
        <v-icon>menu</v-icon>
      </v-btn>
    </th>
    <th>
      <span style="font-size: 20px;">Name - Description</span>
      <br>
      <span>HSN-GST-RATE-UNIT</span>
    </th>
    <th>
      <span style="font-size: 20px;">Opening Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <span style="font-size: 20px;">Purchase Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
      <span style="font-size: 20px;">Sales Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
    
    <th>
       <!-- <v-select
          style="margin-bottom: -35px;"
          :items="stockReportTypes"
          label="Closing Stock"
          v-model="selectedClosingStockType"
        ></v-select> -->
        <span style="font-size: 20px;">Closing Stock</span>
      <br>
      <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
      <span style="float: right;">Amount</span>
    </th>
  </tr>
</template>
      <template slot="items" slot-scope="props">
        <td style="text-align : center">
          <b v-if="props.item['name'] != 'Total'">{{props.index + 1}}</b>
        </td>
        <td>
          <b>{{ props.item['name']}}</b>
        </td>
         <td>
          <span style="float: left;"><b class="font-weight-bold info--text" :title="props.item['openingQuantityTitle']">{{ props.item['openingQuantity']}}</b></span>
          <span style="float: right;"><b >{{ props.item['openingBalance'] || 0 | amount }}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold primary--text" :title="props.item['purchaseQuantityTitle']">{{ props.item['durationQtyPurchase']}}</b></span>
          <span style="float: right;"><b> {{ props.item['durationAmountPurchase'] || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold green--text" :title="props.item['saleQuantityTitle']">{{ props.item['durationQtySale']}}</b></span>
          <span style="float: right;"><b> {{ props.item['durationAmountSale'] || 0 | amount}}</b></span>
        </td>
        <td>
          <span style="float: left;"><b class="font-weight-bold red--text" :title="props.item['closingQuantityTitle']">{{ props.item['closingQuantity']}}</b></span>
          <span style="float: right;"><b>{{props.item['closingAmount']|| 0 | amount}}</b></span>
        </td>
      </template>
      <template slot="no-data">No Items</template>
    </v-data-table>
    <v-data-table :headers="headers" :items="filteredInvoices" class="elevation-1" v-if="['sale','purchase'].indexOf(reportType) > -1">
      <template slot="items" slot-scope="props">
        <td class="text-xs-left nowrap">
          <v-icon @click="openProd(props.item)" color="primary">remove_red_eye</v-icon>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ new Date(props.item.date).toLocaleDateString('en-GB') || '-' }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.buyerName || '-' }}</b>
        </td>
        <td class="text-xs-left">
          <b>{{ props.item.invoiceId || '-' }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b class="font-weight-bold success--text">{{ props.item.totalAmount || 0 | amount }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.GSTTotal) || 0 | amount }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.GSTTotal || 0 | amount }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.discountAmount || 0 | amount }}</b>
        </td>
        <td class="text-xs-left">
          <b class="font-weight-bold primary--text">{{ props.item.paidAmount || 0 | amount }}</b>
        </td>
        <td class="text-xs-left">
          <b class="font-weight-bold error--text">{{ props.item.remainingAmount || 0 | amount }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.duration || '-' }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.daysLeft || '-' }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.paymentType || '-'}}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.status || '-' }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.gstType || '-' }}</b>
        </td>
        <!-- <td class="text-xs-left nowrap">
          <b>{{ props.item.transactionType || null }}</b>
        </td> -->
        <td class="text-xs-left nowrap">
          <b>{{ props.item.mobile || '-' }}</b>
        </td>
        <!-- <td class="text-xs-left nowrap">
          <b>{{ props.item.village || '-' }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.block || '-' }}</b>
        </td> -->
        <td class="text-xs-left nowrap">
          <b>{{ props.item.tehsil || '-' }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.district || '-' }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.state || '-' }}</b>
        </td>
        <td class="text-xs-left nowrap">
          <b>{{ props.item.firmName || '-' }}</b>
        </td>
      </template>
    </v-data-table>
   
     <v-dialog v-model="prodListDialog" fullscreen hide-overlay>
      <v-card>
          <v-toolbar dark color="primary">
            <v-toolbar-title v-if="selectedProduct">
                <b>{{ selectedProduct['name']}}</b> &nbsp; &nbsp; &nbsp; &nbsp;
              <template v-if="selectedProduct['description']">
                Desc : {{ selectedProduct['description']}}&nbsp; &nbsp; &nbsp; &nbsp;
              </template>
              <template v-if="selectedProduct['HSN_code']">
                HSN : {{ selectedProduct['HSN_code']}} &nbsp; &nbsp; &nbsp; &nbsp;
              </template>
              <template v-if="selectedProduct['GST_type']">
                GST Category : {{ selectedProduct['GST_type']}} &nbsp; &nbsp; &nbsp; &nbsp;
              </template>
              <template v-if="selectedProduct['taxableGST_rate']">
                Rate : {{ selectedProduct['taxableGST_rate']}} &nbsp; &nbsp; &nbsp; &nbsp;
              </template>
              <template v-if="selectedProduct['unit']">
                Unit : {{ selectedProduct['unit']}} 
              </template>

            </v-toolbar-title> 
            <v-spacer></v-spacer>
            <v-btn icon dark @click="prodListDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
          <div style="padding: 15px 20px 0px 20px" v-if="Object.keys(filters).length">
          Active Filters:
          <v-row justify="center" align="center">
            <v-chip v-if="filters.date.model" :ripple="false">From Date : {{new Date(filters.date.model).toLocaleDateString('en-GB')}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.tillDate.model" :ripple="false">Till Date : {{new Date(filters.tillDate.model).toLocaleDateString('en-GB')}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.month.model" :ripple="false">Month : {{filters.month.model+1}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.duration.model" :ripple="false">Duration : {{filters.duration.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.firms.model" :ripple="false">Firm : {{filters.firms.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.gstType.model" :ripple="false">GST Type : {{filters.gstType.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.paymentType.model" :ripple="false">Payment Type : {{filters.paymentType.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.status && filters.status.model" :ripple="false">Status : {{filters.status.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.invoiceNumber.model" :ripple="false">Invoice Number : {{filters.invoiceNumber.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.buyerName.model" :ripple="false">Buyer Name : {{filters.buyerName.model}}</v-chip>
          </v-row>
            <v-row justify="center" align="center">
            <v-chip v-if="filters.gstPercentage.model" :ripple="false">GST Percentage : {{filters.gstPercentage.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.isActive.model" :ripple="false">Product Status : {{filters.isActive.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.gstCategory.model" :ripple="false">GST Category : {{filters.gstCategory.model}}</v-chip>
          </v-row>
            <v-row justify="center" align="center">
            <v-chip v-if="filters.hsnCode.model" :ripple="false">HSN : {{filters.hsnCode.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.unit.model" :ripple="false">UNIT : {{filters.unit.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.quantity.model" :ripple="false">Quantity : {{filters.quantity.model}}</v-chip>
          </v-row>
        </div>
        <v-card-text>
          
          <v-data-table
            :headers="productItemListHeader"
            :items="selectProdList"
            class="elevation-1 dashboardHead"
          >
            <template slot="headers" slot-scope="props">
              <tr>
                <th>Invoice</th>
                <th>Date</th>
                <th>
                  <span style="font-size: 20px;">Opening Stock</span>
                  <br>
                  <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
                  <span style="float: right;">Amount</span>
                </th>
                
                <th>
                  <span style="font-size: 20px;">Purchase </span>
                  <br>
                  <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
                  <span style="float: right;">Amount</span>
                </th>

                <th>
                  <span style="font-size: 20px;">Sale </span>
                  <br>
                  <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
                  <span style="float: right;">Amount</span>
                </th>
                
                <th>
                  <span style="font-size: 20px;">Closing stock</span>
                  <br>
                  <span style="float: left;">{{filters.stockReportType.model == 'quantity' ? 'Quantity' : 'Weight'}}</span>
                  <span style="float: right;">Amount</span>
                </th>
              </tr>
            </template>
            <template slot="items" slot-scope="props">
             <td class="text-xs-left nowrap" >
              <v-icon v-if="props.item['date'] != 'Total' && props.item['type'] != 'menufacture' && props.item['type'] != 'damage' && props.item['type'] != 'replace'" @click="openProdInvoice(props.item)" color="primary">remove_red_eye</v-icon>
              <b v-if="props.item['type'] == 'menufacture'">MANUFACTURED</b>
              <b v-if="props.item['type'] == 'damage'">DAMAGED</b>
              <b v-if="props.item['type'] == 'replace'">REPLACED</b>
              </td>
              <td class="text-xs-left nowrap">
                <b v-if="props.item['date'] != 'Total'">{{ new Date(props.item.date).toLocaleDateString('en-GB') || '-' }}</b>
                <b v-else>{{props.item['date']}}</b>
              </td>
              <td>
                <span style="float: left;"><b class="font-weight-bold info--text">{{ props.item['openingQuantity']}}</b></span>
                <span  style="float: right;"><b>{{  props.item['openingBalance'] || 0 | amount}}</b></span>
              </td>
              <td>
                <span style="float: left;"><b class="font-weight-bold green--text">{{ props.item['quantityPurchase']}}</b></span>
                <span style="float: right;"><b> {{ props.item['balancePurchase'] || 0 | amount}}</b></span>
              </td>
              <td>
                <span style="float: left;"><b class="font-weight-bold primary--text">{{ props.item['quantitySale']}}</b></span>
                <span style="float: right;"><b> {{ props.item['balanceSale'] || 0 | amount}}</b></span>
              </td>
              <td>
                <span style="float: left;"><b class="font-weight-bold red--text">{{ props.item['quantityClosing']}}</b></span>
                <span style="float: right;"><b> {{ props.item['balanceCloseing'] || 0 | amount}}</b></span>
              </td>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>
      </v-card>
    </v-dialog>

     <v-dialog v-model="dialog" width="800" persistent>
      <v-card>
        <v-card-title class="headline primary--text" primary-title>
          Product List
          <v-spacer></v-spacer>
          <v-btn icon dark @click="dialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-card-text>
          <v-data-table
            :headers="invoiceProductListHeader"
            :items="selectedInvoice.items"
            class="elevation-1 dashboardHead"
          >
            <template slot="items" slot-scope="props">
              <td>
                <b>{{ props.item['productName']}}</b>
              </td>
              <td>
                <b>{{ props.item['HSN_code']}}</b>
              </td>
              <td>
                <b>{{ props.item['rate']}}</b>
              </td>
              <td>
                <b>{{ props.item.taxableGST_rate}}</b>
              </td>
              <td>
                <b>{{ props.item['productUnit']}}</b>
              </td>
              <td>
                <b>{{ props.item['quantity']}}</b>
              </td>
            </template>
            <template slot="no-data">No Items</template>
          </v-data-table>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Close</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogInvoice" fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card>
        <v-toolbar dark color="primary">
            <v-toolbar-title>
              Invoices List
            </v-toolbar-title> 
            <v-spacer></v-spacer>
            <v-btn icon dark @click="dialogInvoice = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar>
              <div style="padding: 15px 20px 0px 20px" v-if="Object.keys(filters).length">
          Active Filters:
          <v-row justify="center" align="center">
            <v-chip v-if="filters.date.model" :ripple="false">From Date : {{new Date(filters.date.model).toLocaleDateString('en-GB')}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.tillDate.model" :ripple="false">Till Date : {{new Date(filters.tillDate.model).toLocaleDateString('en-GB')}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.month.model" :ripple="false">Month : {{filters.month.model+1}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.duration.model" :ripple="false">Duration : {{filters.duration.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.firms.model" :ripple="false">Firm : {{filters.firms.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.gstType.model" :ripple="false">GST Type : {{filters.gstType.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.paymentType.model" :ripple="false">Payment Type : {{filters.paymentType.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.status && filters.status.model" :ripple="false">Status : {{filters.status.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.invoiceNumber.model" :ripple="false">Invoice Number : {{filters.invoiceNumber.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.buyerName.model" :ripple="false">Buyer Name : {{filters.buyerName.model}}</v-chip>
          </v-row>
            <v-row justify="center" align="center">
            <v-chip v-if="filters.gstPercentage.model" :ripple="false">GST Percentage : {{filters.gstPercentage.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.isActive.model" :ripple="false">Product Status : {{filters.isActive.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.gstCategory.model" :ripple="false">GST Category : {{filters.gstCategory.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.hsnCode.model" :ripple="false">HSN : {{filters.hsnCode.model}}</v-chip>
          </v-row>
           <v-row justify="center" align="center">
            <v-chip v-if="filters.unit.model" :ripple="false">UNIT : {{filters.unit.model}}</v-chip>
          </v-row>
          <v-row justify="center" align="center">
            <v-chip v-if="filters.quantity.model" :ripple="false">Quantity : {{filters.quantity.model}}</v-chip>
          </v-row>
        </div>
        <v-card-text>
          <v-data-table :headers="headers" :items="selectedProdInvoices" class="elevation-1">
            <template slot="items" slot-scope="props">
              <td class="text-xs-left nowrap">
                <v-icon @click="openProd(props.item)" color="primary">remove_red_eye</v-icon>
              </td>
              <!-- <td class="text-xs-left nowrap">
                <b>{{ new Date(props.item.date).toLocaleDateString('en-GB') || '-' }}</b>
              </td> -->
              <td class="text-xs-left nowrap primary--text font-weight-bold" v-html="renderDate(props.item.date)"></td>
              <!-- <td class="text-xs-left nowrap">
                <b>{{ props.item['.key'] || '-' }}</b>
              </td> -->
              <td class="text-xs-left nowrap">
                <b>{{ getCustomerName(props.item.buyerId)|| '-' }}</b>
              </td>
              
              <td class="text-xs-left">
                <b>{{ props.item.invoiceId || '-' }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.totalAmount || 0 | amount }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ Number.parseFloat(props.item.totalAmount) - Number.parseFloat(props.item.GSTTotal) || 0 | amount }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ Number.parseFloat(props.item.GSTTotal) || 0 | amount }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.discountAmount || 0 | amount }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ props.item.paidAmount || '-' }}</b>
              </td>
              <td class="text-xs-left">
                <b>{{ props.item.remainingAmount || '-' }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.duration || '-' }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.daysLeft || '-' }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.paymentType || '-'}}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.status|| '-' }}</b>
              </td>
              <!-- <td class="text-xs-left nowrap">
                <b>{{ props.item.GSTTotal || '-' }}</b>
              </td> -->
              <td class="text-xs-left nowrap">
                <b>{{ props.item.gstType || '-' }}</b>
              </td>
              <!-- <td class="text-xs-left nowrap">
                <b>{{ props.item.transactionType || null }}</b>
              </td> -->
              <td class="text-xs-left nowrap">
                <b>{{ props.item.mobile || '-' }}</b>
              </td>
              <!-- <td class="text-xs-left nowrap">
                <b>{{ props.item.village || '-' }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.block || '-' }}</b>
              </td> -->
              <td class="text-xs-left nowrap">
                <b>{{ props.item.tehsil || '-' }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.district || '-' }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.state || '-' }}</b>
              </td>
              <td class="text-xs-left nowrap">
                <b>{{ props.item.firmName || '-' }}</b>
              </td>
            </template>
          </v-data-table>
        </v-card-text>
        <v-divider></v-divider>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
import { convertToPDFStockReport } from "../../utils/pdf-reports/stocks-reports";
export default {
  props: ["filters", "reportType",'selectedClosingStockType'],
  data() {
    return {
      headers: [
        { text: "Products", value: "action" },
        { text: "Date", value: "date", sortable: true },
        // { text: "Invoice-Key", value: "Name" },
        { text: "Buyer Name", value: "Father Name" },
        { text: "Invoice ID", value: "Block" },
        { text: "Total Amount", value: "totalCurrentAmount" },
        { text: "Basic Amount", value: "basic" },
        { text: "GST", value: "GST" },
        { text: "Discount", value: "totalCurrentAmount" },
        { text: "Paid Amount", value: "Tehsil" },
        { text: "Due Amount", value: "District" },
        { text: "Duration (in Days)", value: "abs" },
        { text: "Days Left", sortable: true, value: "daysLeft" },
        { text: "Payment Type", value: "Identity Number" },
        { text: "Status", value: "Mobile" },        
        { text: "GST type", value: "gst type" },
        // { text: "Transaction Type", sortable: true, value: "paymentType" },
        { text: "Mobile", value: "mobile" },
        // { text: "Village", value: "village" },
        // { text: "Block", value: "block" },
        { text: "Tehsil", value: "tehsil" },
        { text: "District", value: "district" },
        { text: "State", value: "state" },        
        { text: "Firm Name", value: "Village" },
      ],
      productListHeader: [
        { text: "Invoices", value: "action" },
        { text: "Name, Description, HSN, GST type, Rate, Unit", value: "Name" },
        { text: "Quantity", value: "quantity" },
        { text: "Duration quantity", value: "quantity" },
        { text: "Amount", value: "quantity" },
        { text: "Opening Quantity", value: "quantity" },
        { text: "Sale Quantity", value: "quantity" },
        { text: "Duration Sale quantity", value: "quantity" },
        { text: "Sale Amount", value: "quantity" },
        { text: "Purchase Quantity", value: "quantity" },
        {
          text: "Duration Purchase quantity",
          value: "quantity"
        },
        { text: "Purchase Amount", value: "quantity" },
      ],

      productItemListHeader: [
        { text: "Invoices", value: "action" },
        { text: "Date", value: "Name" },
        { text: "Amount", value: "quantity" },
        { text: "Opening Quantity", value: "quantity" },
        { text: "Sale Quantity", value: "quantity" },
        { text: "Duration Sale quantity", value: "quantity" },
        { text: "Sale Amount", value: "quantity" },
        { text: "Purchase Quantity", value: "quantity" },
        { text: "Duration Purchase quantity", value: "quantity"},
        { text: "Purchase Amount", value: "quantity" },
      ],
      invoiceProductListHeader: [
        { text: "Product Name", value: "productName" },
        { text: "HSN code", value: "HSN" },
        { text: "Product rate", value: "rate" },
        { text: "GST %", value: "GST Rate" },
        { text: "Unit", value: "Unit" },
        { text: "Quantity", value: "quantity" }
      ],
      firms: {},
      search : null,
      buyerById: {},
      selectedInvoice: {},
      dialog: false,
      selectedProdInvoices: [],
      selectProdList : [],
      prodListDialog : false,
      selectedProduct : {},
      dialogInvoice: false,
      dialogStockReports : false
    };
  },
  created() {
    this.$bindAsArray("invoices", this.$root.$firebaseRefs.invoice.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsObject("firms", this.$root.$firebaseRefs.firm);
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer);
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller);
    this.$bindAsArray("productList", this.$root.$firebaseRefs.products.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray(
      'productGroups',
      this.$root.$firebaseRefs.productGroup.orderByChild('brand').equalTo(this.selectedBrand)
    )
     this.$bindAsArray(
      'productMenufs',
      this.$root.$firebaseRefs.productManufactureTransaction.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'productDmg',
      this.$root.$firebaseRefs.productDamageTransaction.orderByChild('brand').equalTo(this.selectedBrand)
    )
    this.$bindAsArray(
      'productRep',
      this.$root.$firebaseRefs.productReplaceTransaction.orderByChild('brand').equalTo(this.selectedBrand)
    )
  },
  methods: {
      getClosingAmount(item) {
      let closingQty = item['closingQuantity']
      switch(this.selectedClosingStockType) {
        
        case 'APP' :{
          let avgPurchasePrice = item.stockReportData.purchaseDetails.length ? (item.stockReportData.purchaseDetails.reduce((a, b) => a + (b['rate'] || 0), 0))/item.stockReportData.purchaseDetails.length : 0;
          return (avgPurchasePrice * closingQty);
        }
        case 'LPP' :{
          return (item.stockReportData.lastPurchasePrice * closingQty);
        }
        case 'LSP' :{
          return (item.stockReportData.lastSalePrice * closingQty);
        }
        case 'ASP' :{
          let avgSalePrice = (item.stockReportData.saleDetails.reduce((a, b) => a + (b['rate'] || 0), 0))/item.stockReportData.saleDetails.length
          return (avgSalePrice * closingQty);
        }
        case 'FIFO' :{
  
          let allTransaction = item.stockReportData.purchaseDetails.sort(function(a,b){
            return -(new Date(b.date) - new Date(a.date));
          });
          let amount = 0;
          let qntTemp = closingQty;
          allTransaction.map((t)=>{
            if(qntTemp>t.quantity) {
              amount += (t.quantity * t.rate);
              qntTemp = qntTemp-t.quantity
            } else if(qntTemp > 0) {
               amount += (t.quantity-qntTemp * t.rate);
               qntTemp = 0;
            }
          })
          return amount;
        }
        case 'LIFO' :{
          let allTransaction = item.stockReportData.purchaseDetails.sort(function(a,b){
            return new Date(b.date) - new Date(a.date);
          });
          let amount = 0;
          let qntTemp = closingQty;
          allTransaction.map((t)=>{
            if(qntTemp>t.quantity) {
              amount += (t.quantity * t.rate);
              qntTemp = qntTemp-t.quantity
            } else if(qntTemp > 0) {
               amount += (t.quantity-qntTemp * t.rate);
               qntTemp = 0;
            }
          })
          return amount;
        }
      }
    },
    renderDate(timeStamp) {
      if (timeStamp) {
        return new Date(timeStamp).toLocaleDateString("en-GB");
      }
      return "--";
    },
    printStockReports(){
      const htmlToArray = (tableElement) => {
        const thead = tableElement.querySelector("thead");
        const tbody = tableElement.querySelector("tbody");
        // Assumes there's only one header row
        const columns = thead.querySelectorAll("tr th");
        const columnNames = [];
        columns.forEach((c) => columnNames.push(c.innerText));
        const result = [];
        const bodyRows = tbody.querySelectorAll("tr");
        bodyRows.forEach((r) => {
          const tds = r.querySelectorAll("td");
          const arr = [];
          tds.forEach((td, idx) => {
            arr.push(td.innerText);
          });
          result.push(arr);
        });
        return result;
      };
      const table = document.querySelector(".stocks-reports");
      let invoices = htmlToArray(table);
      let doc = convertToPDFStockReport({
        invoiceData: invoices,
        firm : this.filters.firms.model ? this.getFirmName(this.filters.firms.model) : '',
        fromDate : this.filters.date.model ? new Date(this.filters.date.model).toLocaleDateString('en-GB') : '',
        toDate : this.filters.tillDate.model ? new Date(this.filters.tillDate.model).toLocaleDateString('en-GB') : ''
      });
      pdfMake.createPdf(doc).download('Stock Register');
    },
     getFilteredQuantity(product,qty){
      let quantity = qty;
      let string = "";
          product.unitsDetails.sort(function(a,b){
            return (b.order - a.order);
          });
          for (var i = 0; i < product.unitsDetails.length; i++) {
             if(quantity > Number.parseFloat(product.unitsDetails[i].quantity) && i+1 <product.unitsDetails.length) {
              let temp  = Number.parseFloat(quantity)%Number.parseFloat(product.unitsDetails[i].quantity);
               let temp1  = Number.parseFloat(quantity)/Number.parseFloat(product.unitsDetails[i].quantity);
                string = (("("+temp + " "+product.unitsDetails[i].unit+") ")+ string);
                quantity = Number.parseInt((temp1).toString().split(".")[0])
              } else {
                string = (("("+quantity + " "+product.unitsDetails[i].unit+") ")+ string);
                break;
              }
          }
          console.log(string)
        return string;
    },
    // productListByBrand() {
    //   return this.productList.filter(
    //     item => {
    //       return (item["brand"] === this.selectedBrand && 
    //       (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true) &&
    //       (!!this.search ? !!item["name"].toLowerCase().includes(this.search.toLowerCase()) : true))
    //     }
    //   );
    // },
    keymonitor(event){
      this.search = event.target.value;
    },
    getFirmName(firmId) {
      if (this.firms && this.firms[firmId]) {
        return this.firms[firmId]["name"];
      }
      return "--";
    },
    getCustomerName(id) {
      let buyer = this.buyerById[id];
      let seller = this.sellerById[id];
      return buyer ? buyer.name : seller.name;
    },
    openProd(invoice) {
      this.selectedInvoice = invoice;
      this.dialog = true;
    },
    openProdInvoice(product) {
      this.selectedProdInvoices = [product.invoice];
      this.dialogInvoice = true;
    },
    openProdItems(product) {
      this.selectProdList = product.productList ? Array.from(product.productList) : [];
      this.selectProdList.sort(function(a,b){
        return -(new Date(b.date) - new Date(a.date));
      });
       this.selectedProduct = product;
      // let total = {
      //   date : 'Total',
      //   openingQuantity :0,
      //   openingBalance : 0,
      //   quantitySale : 0,
      //   quantityPurchase : 0,
      //   balanceSale : 0,
      //   balancePurchase : 0 ,
      //   quantityClosing : 0,
      //   balanceCloseing : 0
      // };
      let isQuantity = this.filters.stockReportType.model == 'quantity';
      this.selectProdList.map((product,index)=>{
        this.selectProdList[index]['openingQuantity'] = index == 0 ? product['openingQuantity'] : this.selectProdList[index-1]['quantityClosing'];
        //total['openingQuantity'] += parseInt(this.selectProdList[index]['openingQuantity']);

        this.selectProdList[index]['openingBalance'] = index == 0 ? product['openingBalance'] : this.selectProdList[index-1]['balanceCloseing'];
       // total['openingBalance'] += Number.parseFloat(this.selectProdList[index]['openingBalance']);

        this.selectProdList[index]['quantitySale'] = product.isBuyer ? (isQuantity ? product['quantity'] : Number.parseFloat(product['netWeight']).toFixed(3)) : 0
        //total['quantitySale'] +=  parseInt(this.selectProdList[index]['quantitySale']);

        this.selectProdList[index]['quantityPurchase'] = !product.isBuyer ? (isQuantity ? product['quantity'] : Number.parseFloat(product['netWeight']).toFixed(3)) : 0
        //total['quantityPurchase'] +=  parseInt(this.selectProdList[index]['quantityPurchase']);

        this.selectProdList[index]['balanceSale'] = product.isBuyer ? ((Number.parseFloat(product['basicPrice']) + Number.parseFloat(product['GSTValue'])).toFixed(2)) : 0
        //total['balanceSale'] += isNaN(Number.parseFloat(this.selectProdList[index]['balanceSale'])) ? 0 : Number.parseFloat(this.selectProdList[index]['balanceSale']);

        this.selectProdList[index]['balancePurchase'] = !product.isBuyer ? ((Number.parseFloat(product['basicPrice']) + Number.parseFloat(product['GSTValue'])).toFixed(2)) : 0
        //total['balancePurchase'] += isNaN(Number.parseFloat(this.selectProdList[index]['balancePurchase'])) ? 0 : Number.parseFloat(this.selectProdList[index]['balancePurchase']);

        this.selectProdList[index]['quantityClosing'] = Number.parseFloat(Number.parseInt(product['openingQuantity']) + Number.parseFloat(product.isBuyer ? (-(isQuantity ? product['quantity'] : Number.parseFloat(product['netWeight']).toFixed(3))) : (isQuantity ? product['quantity'] : Number.parseFloat(product['netWeight'])) )).toFixed(3)
        //total['quantityClosing'] +=  parseInt(this.selectProdList[index]['quantityClosing']);

        this.selectProdList[index]['balanceCloseing'] = Number.parseFloat(product['openingBalance']) + (product.isBuyer ? (-((Number.parseFloat(product['basicPrice']) + Number.parseFloat(product['GSTValue'])))) : (((Number.parseFloat(product['basicPrice']) + Number.parseFloat(product['GSTValue'])))))
        //total['balanceCloseing'] += Number.parseFloat(this.selectProdList[index]['balanceCloseing']);

      })
 
      // this.selectProdList.push(total)
      this.prodListDialog = true;
      if(product.openingDate && product.openingQuantity) {
        if (this.filters.tillDate.model && this.filters.date.model) {
          let fromDate = new Date(this.filters.date.model.split("-")).getTime();
          let tillDate = new Date(
            this.filters.tillDate.model.split("-")
          ).getTime();
          let itemDate = new Date(product.openingDate).getTime();

          if (fromDate <= itemDate && tillDate >= itemDate) {
            this.selectProdList.splice(0, 0, {
              date : product.openingDate,
              openingQuantity :product.openingQuantity,
              openingBalance : product.openingBalance,
              quantitySale : 0,
              quantityPurchase : 0,
              balanceSale : 0,
              balancePurchase : 0 ,
              quantityClosing : 0,
              balanceCloseing : 0
            })
          }
        }
      }
    }
  },
  
  watch: {
    filters(val) {},
      reportType(val) {
        if (val == "sale") {
          this.headers.splice(2, 1, { text: "Buyer Name", value: "Father Name" });
        } else if (val == "purchase") {
          this.headers.splice(2, 1, {
            text: "Seller Name",
            value: "Father Name"
          });
        }
      },
      dialogStockReports(val){
         if (val) {
          setTimeout(() => {
            document.querySelector('.product-report-search input').click();
          }, 500);
        }
      }
    },
  computed: {
    ...mapGlobalGetters(["selectedBrand", "finYear","stockReportTypes", "brandFinYear"]),
    invoiceList() {
      let result = [];
      if (this.invoices) {
        let filteredInvoices = this.invoices.filter(item => {
          // return item["brand"] === this.selectedBrand;
          return (item["brand"] === this.selectedBrand 
          &&  (item.deleted != true)) 
          // && (item.date >= this.finYear.start) 
          // && (item.date <= this.finYear.end))
        });
        filteredInvoices.forEach(element => {
          if (element.items) {
            let GSTTotal = 0;
            element.items.map(item => {
              GSTTotal += Number.parseFloat(item.GSTValue);
            });
            element["GSTTotal"] = GSTTotal;
          }
          let localDate = new Date(element["date"]);
          let dt2 = new Date();
          let dt1 = localDate;
          let daysSpent = Math.floor(
            (Date.UTC(dt2.getFullYear(), dt2.getMonth(), dt2.getDate()) -
              Date.UTC(dt1.getFullYear(), dt1.getMonth(), dt1.getDate())) /
              (1000 * 60 * 60 * 24)
          );

          element["dateCompare"] = new Date(element["date"]).toLocaleDateString(
            "en-GB"
          );
          element["closedDate"] = element["closedDate"]
            ? new Date(element["closedDate"]).toLocaleDateString("en-GB")
            : null;
          element["daysLeft"] = element["duration"] - daysSpent;
          element["duration"] = daysSpent;
          let rate = (element["rate"] * 12) / 100;
          let time = element["duration"] / 365;
          let principal = element["totalAmount"];
          let amount = principal * (1 + rate * time);
          element["interestValue"] = (amount - element["totalAmount"]).toFixed(
            2
          );
          element["totalValue"] = amount.toFixed(2);
          time = daysSpent / 365;
          amount = principal * (1 + rate * time);
          element["currentInterestValue"] = (
            amount - element["totalAmount"]
          ).toFixed(2);
          element["currentTotalValue"] = amount.toFixed(2);

          let firm = this.firms[element["firm"]];
          if (this.firms[element["firm"]]) {
            element["firmName"] = firm["name"];
          } else {
            element["firmName"] = "--";
          }

          if (element["isBuyer"] == true && this.reportType == "sale") {
            const buyerId = element["buyerId"];
            const buyer = this.buyerById[buyerId];

            if (buyer) {
              element["buyerName"] = buyer["name"] || "-";
              element["propName"] = buyer["propName"] || "-";
              element["village"] = buyer["village"] || "-";
              element["block"] = buyer["block"] || "-";
              element["mobile"] = buyer["mobile"] || "-";
              element["state"] = buyer["state"] || "-";
              element["district"] = buyer["district"] || "-";
              element["tehsil"] = buyer["tehsil"] || "-";
            }
            result.push(element);
          }

          if (element["isBuyer"] == false && this.reportType == "purchase") {
            const sellerID = element["buyerId"];
            const seller = this.sellerById[sellerID];

            if (seller) {
              element["buyerName"] = seller["name"] || "-";
              element["propName"] = seller["propName"] || "-";
              element["village"] = seller["village"] || "-";
              element["block"] = seller["block"] || "-";
              element["mobile"] = seller["mobile"] || "-";
              element["state"] = seller["state"] || "-";
              element["district"] = seller["district"] || "-";
              element["tehsil"] = seller["tehsil"] || "-";
            }
            result.push(element);
          }
        });
      }
      return result;
    },
    // productListByBrand() {
    //   return this.productList.filter(
    //     item => (item["brand"] === this.selectedBrand &&        
    //     (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true))
    //   );
    // },
    productListByBrand() {
      return this.productList.filter(
        item => {
          return (item["brand"] === this.selectedBrand && 
          // (item.openingDate ? (item.openingDate >= this.finYear.start) && (item.openingDate <= this.finYear.end) : true) &&
          (!!this.search ? !!item["name"].toLowerCase().includes(this.search.toLowerCase()) : true))
        }
      );
    },
    filteredProduct() {
      let products = this.productListByBrand.filter(item => {
        if (!Object.keys(this.filters).length) {
          return true;
        }

        if (this.filters.gstPercentage.model) {
          if (this.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        } else if (this.filters.gstPercentage.model == 0) {
          if (this.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        }

        if (this.filters.firms.model) {
          if (this.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (this.filters.productGroups.model) {
          if (this.filters.productGroups.model !== item["productGroup"]) {
            return false;
          }
        }

        if (this.filters.isActive.model) {
          if (this.filters.isActive.model !== item["isActive"]) {
            return false;
          }
        }

        if (this.filters.gstCategory.model) {
          if (this.filters.gstCategory.model !== item["GST_type"]) {
            return false;
          }
        }

        if (this.filters.unit.model) {
          if (this.filters.unit.model !== item["unit"]) {
            return false;
          }
        }

        if (this.filters.hsnCode.model) {
          if (this.filters.hsnCode.model !== item["HSN_code"]) {
            return false;
          }
        }

        if (this.filters.quantity.model) {
          if (item["quantity"] >= this.filters.quantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.openingQuantity.model) {
          if (item["openingQuantity"] >= this.filters.openingQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.saleQuantity.model) {
          if (item["saleQuantity"] >= this.filters.saleQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.purchaseQuantity.model) {
          if (item["purchaseQuantity"] >= this.filters.purchaseQuantity.model) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      });
      let total = {
        quantity : 0,
        durationQuantity : 0,
        durationAmount : 0,
        saleQuantity : 0,
        durationQtySale : 0,
        durationAmountSale : 0,
        purchaseQuantity : 0,
        durationQtyPurchase : 0,
        durationAmountPurchase : 0,
        openingQuantity : 0,
        openingBalance : 0,
        closingAmount : 0,
        closingQuantity : 0,
      }
      products.map(p => {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["closingAmount"] = 0;
        p["closingQuantity"] = 0;
        p["stockReportData"] = {
          saleDetails : [],
          purchaseDetails : [],
          lastSalePrice : 0,
          lastPurchasePrice : 0
        } 
        if(p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            quantity : Number.parseInt(p.openingQuantity),
            rate : (Number.parseFloat(p.openingBalance)/ Number.parseInt(p.openingQuantity)),
            date: p.openingDate
          })
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity += Number.parseFloat(p["openingQuantity"] ? p["openingQuantity"] : 0)
        total.openingBalance +=  Number.parseFloat(p["openingBalance"] ? p["openingBalance"] : 0)
      });
      let productGroup = products.reduce(function(r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, Object.create(null));
      Object.keys(productGroup).forEach(function(key) {
        productGroup[key][0]['productList'] = []
      });
      let latestSaleDate = new Date('01-01-1000').getTime();
      let latestPurchaseDate = new Date('01-01-1000').getTime();
      let filteredInvoices = this.invoices.filter(item => {
        
        if (!Object.keys(this.filters).length) {
          return true;
        }

        if (item.type == "automatic invoice") {
          return false;
        }

        if (!item.items || !item.items.length) {
          return false;
        }

         if (item.deleted) {
          return false;
        }

        if (this.filters.tillDate.model && this.filters.date.model) {
          let fromDate = new Date(this.filters.date.model.split("-")).getTime();
          let tillDate = new Date(
            this.filters.tillDate.model.split("-")
          ).getTime();
          let itemDate = new Date(item["date"]).getTime();

          if (fromDate > itemDate|| tillDate < itemDate) {
            return false;
          }
        } else if (this.filters.date.model) {
          const [year, month, day] = this.filters.date.model.split("-");
          const date = `${day}/${month}/${year}`;
          if (item["dateCompare"] !== date) {
            return false;
          }
        }

        if (!item["date"]) {
            return false;
        }

        if (this.filters.month.model) {
          let month = this.filters.month.model;
          if (!(new Date(item["date"]).getMonth() == month)) {
            return false;
          }
        }

        if (this.filters.duration.model) {
          if (item["duration"] >= this.filters.duration.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.firms.model) {
          if (this.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (this.filters.gstType.model) {
          if (this.filters.gstType.model !== item["gstType"]) {
            return false;
          }
        }

        // if (this.filters.amount.model) {
        //   if (item["totalValue"] >= this.filters.amount.model) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }
        // if (this.filters.duration.model) {
        //   if (item["duration"] >= this.filters.duration.model) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }

        // if (this.filters.rate.model) {
        //   if (this.filters.rate.model !== item["rate"]) {
        //     return false;
        //   }
        // }

        if (this.filters.paymentType.model) {
          if (item["paymentType"] === this.filters.paymentType.model) {
            return true;
          } else {
            return false;
          }
        }
        if (this.filters.invoiceStatus.model) {
          if (item["status"] === this.filters.invoiceStatus.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.invoiceNumber.model) {
          if (item[".key"] !== this.filters.invoiceNumber.model) {
            return false;
          }
        }

        if (this.filters.buyerName.model) {
          if (item["buyerId"] !== this.filters.buyerName.model) {
            return false;
          }
        }

        if (this.filters.gstPercentage.model) {
          if (
            !item.items.find(
              p => p["taxableGST_rate"] === this.filters.gstPercentage.model
            )
          ) {
            return false;
          }
        }

        if (this.filters.gstCategory.model) {
          if (
            !item.items.find(
              p => p["GST_type"] === this.filters.gstCategory.model
            )
          ) {
            return false;
          }
        }

        if (this.filters.isActive.model) {
          if (
            !item.items.find(
              p => p["isActive"] === this.filters.isActive.model
            )
          ) {
            return false;
          }
        }

        if (this.filters.hsnCode.model && item.items) {
          if (
            !item.items.find(p => p["HSN_code"] == this.filters.hsnCode.model)
          ) {
            return false;
          }
        }

        if (this.filters.unit.model) {
          if (
            !item.items.find(p => p["productUnit"] === this.filters.unit.model)
          ) {
            return false;
          }
        }

        if (this.filters.quantity.model) {
          if (
            item.items.find(p => p["quantity"] >= this.filters.quantity.model)
          ) {
            return true;
          } else {
            return false;
          }
        }

        // if (this.filters.gstPercentage.model) {
        //   // if (item["buyerId"] !== this.filters.buyerName.model) {
        //   //   return false;
        //   // }
        // }
        return true;
      });
      this.selectProdList = [];

      this.productMenufs.map((pmf)=>{
        //let product = this.productListByBrand.find(item => item['.key'] == pmf.productId);
        filteredInvoices.push(
          {
            isBuyer : false,
            date : pmf.date,
            type : 'menufacture',
            items : [
              {
                productId : pmf.productId,
                quantity : pmf.quantity,
                basicPrice : 0,
                GSTValue : 0,
                type : 'menufacture'

              }
            ]
          }
        )
        pmf.rawMaterials.map((raw)=>{
          filteredInvoices.push(
          {
            isBuyer : true,
            date : pmf.date,
            type : 'menufacture',
            items : [
              {
                productId : raw.productId,
                quantity : raw.quantity,
                basicPrice : 0,
                GSTValue : 0,
                type : 'menufacture'

              }
            ]
          }
        )
        })
      })
        this.productDmg.map((pmf)=>{
        //let product = this.productListByBrand.find(item => item['.key'] == pmf.productId);
        filteredInvoices.push(
          {
            isBuyer : true,
            date : pmf.date,
            type : 'damage',
            items : [
              {
                productId : pmf.productId,
                quantity : pmf.quantity,
                basicPrice : 0,
                GSTValue : 0,
                type : 'damage'

              }
            ]
          }
        )
        })

        this.productRep.map((pmf)=>{
        filteredInvoices.push(
          {
            isBuyer : true,
            date : pmf.date,
            type : 'replace',
            items : [
              {
                productId : pmf.productId,
                quantity : pmf.quantity,
                basicPrice : 0,
                GSTValue : 0,
                type : 'replace'

              }
            ]
          }
        )
        filteredInvoices.push(
          {
            isBuyer : false,
            date : pmf.date,
            type : 'replace',
            items : [
              {
                productId : pmf.newProductId,
                quantity : pmf.newProductQuantity,
                basicPrice : 0,
                GSTValue : 0,
                type : 'replace'

              }
            ]
          }
        )
        })


      filteredInvoices.map(invoice => {
        let invoiceMonth = new Date(invoice.date).getMonth();
        if (
          (!!this.filters.month.model
            ? invoiceMonth <= this.filters.month.model
            : true) &&
          !invoice.return &&
          Object.keys(productGroup).length
        ) {
          
          let isBuyer = invoice.isBuyer;
          invoice.items &&
            invoice.items.map(item => {
              if(productGroup[item["productId"]]) {
                 if (
                productGroup[item["productId"]][0].durationQuantity != undefined
              ) {
                let durationQuantity = parseInt(
                  productGroup[item["productId"]][0]["durationQuantity"]
                );
                durationQuantity += !!isBuyer
                  ? -parseInt(item.quantity)
                  : parseInt(item.quantity);
                total.durationQuantity += durationQuantity;
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = durationQuantity;
              } else {
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = productGroup[item["productId"]][0].openingQuantity
                  ? productGroup[item["productId"]][0].openingQuantity
                  : 0;
                  total.durationQuantity += parseInt(productGroup[item["productId"]][0][
                  "durationQuantity"
                ]);
              }
              // if (productGroup[item["productId"]][0]["invoices"] && productGroup[item["productId"]][0]["invoices"].length) {
              //   productGroup[item["productId"]][0]["invoices"].push(invoice);
              // } else {
              //   productGroup[item["productId"]][0]["invoices"] = [];
              //   productGroup[item["productId"]][0]["invoices"].push(invoice);
              // }
              if(productGroup[item["productId"]][0].unitsDeatilsAdded) {
                let units = [...productGroup[item["productId"]][0].unitsDetails];
                units.sort((a, b) => parseFloat(a.order) - parseFloat(b.order));

                let isSelectedUnit = false;
                let multiplayer = 1;
                units.map(unit =>{
                  if(isSelectedUnit && parseInt(unit.quantity) >0) {
                    multiplayer = multiplayer*parseInt(unit.quantity);
                  }
                  if(unit.unit == item.unit) {
                    isSelectedUnit = true;
                  }
                })
                item.quantity = item.quantity * multiplayer;
              }

              let rate = (Number.parseFloat(item.rate));
              if(isBuyer) {
                if(invoice.date > latestSaleDate) {
                  latestSaleDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              } else {
                if(invoice.date > latestPurchaseDate) {
                  latestPurchaseDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                  quantity : item.quantity,
                  rate : rate,
                  date : invoice.date
                })
              }
              productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer
                ? -Number.parseFloat(item.basicPrice)
                : Number.parseFloat(item.basicPrice);
                total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
              if (!!isBuyer) {
                productGroup[item["productId"]][0][
                  "durationQtySale"
                ] += parseInt(item.quantity);
                total.durationQtySale += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountSale"
                ] += (Number.parseFloat(item.basicPrice));
                total.durationAmountSale += Number.parseFloat(item.basicPrice);
              } else {
                productGroup[item["productId"]][0][
                  "durationQtyPurchase"
                ] += parseInt(item.quantity);
                total.durationQtyPurchase += parseInt(item.quantity);
                productGroup[item["productId"]][0][
                  "durationAmountPurchase"
                ] += Number.parseFloat(item.basicPrice);
                total.durationAmountPurchase += Number.parseFloat(item.basicPrice);
              }
              item['date'] = invoice.date;
              item['invoice'] = invoice;
              item['isBuyer'] = invoice['isBuyer'];
              item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance']
              item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity']

    
              if(!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length))
                { 
                  productGroup[item["productId"]][0]['productList'] = [];
                }
              productGroup[item["productId"]][0]['productList'].push(item)
              }
              
            });
        }
      });
      let results = [];
      let self = this;
      Object.keys(productGroup).length &&
        Object.keys(productGroup).map(function(key, index) {
          productGroup[key][".key"] = key;
          
            if(productGroup[key][0].unitsDeatilsAdded) {
              productGroup[key][0]['openingQuantityTitle']= self.getFilteredQuantity(productGroup[key][0],productGroup[key][0]['openingQuantity'])
              productGroup[key][0]['purchaseQuantityTitle']= self.getFilteredQuantity(productGroup[key][0],productGroup[key][0]['durationQtyPurchase'])
              productGroup[key][0]['saleQuantityTitle']= self.getFilteredQuantity(productGroup[key][0],productGroup[key][0]['durationQtySale'])
              productGroup[key][0]['closingQuantityTitle']= self.getFilteredQuantity(productGroup[key][0],((Number.parseFloat(productGroup[key][0]['openingQuantity']) + Number.parseFloat(productGroup[key][0]['durationQtyPurchase'])) -  Number.parseFloat(productGroup[key][0]['durationQtySale'])))
            }
          productGroup[key][0]['closingQuantity'] = (parseInt(productGroup[key][0]['openingQuantity'] ?  productGroup[key][0]['openingQuantity'] : 0) + parseInt(productGroup[key][0]['durationQtyPurchase'] ?  productGroup[key][0]['durationQtyPurchase'] : 0)) - parseInt( productGroup[key][0]['durationQtySale'] ?  productGroup[key][0]['durationQtySale'] : 0)
          total.closingQuantity += isNaN(productGroup[key][0]['closingQuantity']) ? 0 : productGroup[key][0]['closingQuantity'];

          productGroup[key][0]['closingAmount'] = self.getClosingAmount(productGroup[key][0])
          // total.closingAmount += Number.parseFloat(productGroup[key][0]['closingAmount'])
          let closingStockVal = Number.parseFloat(productGroup[key][0]['closingAmount'])
          total.closingAmount += isNaN(closingStockVal) ? 0 : closingStockVal;
          // productGroup[key][0]['closingQuantity'] = (parseInt(productGroup[key][0]['openingQuantity'] ?  productGroup[key][0]['openingQuantity'] : 0) + parseInt(productGroup[key][0]['durationQtyPurchase'] ?  productGroup[key][0]['durationQtyPurchase'] : 0)) - parseInt( productGroup[key][0]['durationQtySale'] ?  productGroup[key][0]['durationQtySale'] : 0)
          // total.closingQuantity += isNaN(productGroup[key][0]['closingQuantity']) ? 0 : productGroup[key][0]['closingQuantity'];
          results.push(productGroup[key][0]);
        });
        results.push({
            name : 'Total',
            ".key" : 'total',
            quantity : total.quantity,
            durationQuantity : total.durationQuantity,
            durationAmount : total.durationAmount,
            saleQuantity : total.saleQuantity,
            durationQtySale : total.durationQtySale,
            durationAmountSale : total.durationAmountSale,
            purchaseQuantity : total.purchaseQuantity,
            durationQtyPurchase : total.durationQtyPurchase,
            durationAmountPurchase : total.durationAmountPurchase,
            openingQuantity : total.openingQuantity,
            openingBalance : total.openingBalance,
            closingAmount : total.closingAmount,
            closingQuantity : total.closingQuantity
          })
      return results;
    },
    filteredProductByWeight(){
      let products = this.productListByBrand.filter(item => {
        if (!Object.keys(this.filters).length) {
          return true;
        }

        if (this.filters.gstPercentage.model) {
          if (this.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        } else if (this.filters.gstPercentage.model == 0) {
          if (this.filters.gstPercentage.model !== item["taxableGST_rate"]) {
            return false;
          }
        }

        if (this.filters.firms.model) {
          if (this.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (this.filters.productGroups.model) {
          if (this.filters.productGroups.model !== item["productGroup"]) {
            return false;
          }
        }

        if (this.filters.gstCategory.model) {
          if (this.filters.gstCategory.model !== item["GST_type"]) {
            return false;
          }
        }

        if (this.filters.isActive.model) {
          if (this.filters.isActive.model !== item["isActive"]) {
            return false;
          }
        }


        if (this.filters.unit.model) {
          if (this.filters.unit.model !== item["unit"]) {
            return false;
          }
        }

        if (this.filters.hsnCode.model) {
          if (this.filters.hsnCode.model !== item["HSN_code"]) {
            return false;
          }
        }

        if (this.filters.quantity.model) {
          if (item["quantity"] >= this.filters.quantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.openingQuantity.model) {
          if (item["openingQuantity"] >= this.filters.openingQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.saleQuantity.model) {
          if (item["saleQuantity"] >= this.filters.saleQuantity.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.purchaseQuantity.model) {
          if (item["purchaseQuantity"] >= this.filters.purchaseQuantity.model) {
            return true;
          } else {
            return false;
          }
        }
        return true;
      });
      let total = {
        quantity : 0,
        durationQuantity : 0,
        durationAmount : 0,
        saleQuantity : 0,
        durationQtySale : 0,
        durationAmountSale : 0,
        purchaseQuantity : 0,
        durationQtyPurchase : 0,
        durationAmountPurchase : 0,
        openingQuantity : 0,
        openingBalance : 0,
        closingAmount : 0,
        closingQuantity : 0,
      }
      products.map((p,index) => {
        p["durationQuantity"] = undefined;
        p["durationAmount"] = 0;
        p["durationQtySale"] = 0;
        p["durationQtyPurchase"] = 0;
        p["durationAmountSale"] = 0;
        p["durationAmountPurchase"] = 0;
        p["closingAmount"] = 0;
        p["closingQuantity"] = 0;
        p["stockReportData"] = {
          saleDetails : [],
          purchaseDetails : [],
          lastSalePrice : 0,
          lastPurchasePrice : 0
        } 
        
        let prodG = {
          weight : 0,
          openingBalance : 0,
        }
        if(this.reportType == 'productGroup') {
          if(p.productGroup) {
            prodG = this.productGroups.find(item => item['.key'] == p.productGroup)
          }
          products[index]['openingQuantity'] = Number.parseFloat(prodG.weight || 0);
          products[index]['openingBalance'] = Number.parseFloat(prodG.openingBalance || 0);
        } else {
          products[index]['openingQuantity'] = 0;
          products[index]['openingBalance'] = 0;
        }
         
        if(p.openingBalance && p.openingQuantity) {
          p["stockReportData"]['purchaseDetails'].push({
            quantity : Number.parseFloat(p.openingQuantity),
            rate : (Number.parseFloat(p.openingBalance)/ Number.parseFloat(p.openingQuantity)),
            date: p.openingDate
          })
          p["stockReportData"]['lastPurchasePrice'] = p.openingBalance;
        }
        total.openingQuantity = '34821.947'
        total.openingBalance =  '5414046.90'
      });
      let productGroup = products.reduce(function(r, a) {
        r[a[".key"]] = r[a[".key"]] || [];
        r[a[".key"]].push(a);
        return r;
      }, Object.create(null));
      Object.keys(productGroup).forEach(function(key) {
        productGroup[key][0]['productList'] = []
      });
      let latestSaleDate = new Date('01-01-1000').getTime();
      let latestPurchaseDate = new Date('01-01-1000').getTime();
      let filteredInvoices = this.invoices.filter(item => {
        
        if (!Object.keys(this.filters).length) {
          return true;
        }

        if (item.type == "automatic invoice") {
          return false;
        }

        if (!item.items || !item.items.length) {
          return false;
        }

         if (item.deleted) {
          return false;
        }

        if (this.filters.tillDate.model && this.filters.date.model) {
          let fromDate = new Date(this.filters.date.model.split("-")).getTime();
          let tillDate = new Date(
            this.filters.tillDate.model.split("-")
          ).getTime();
          let itemDate = new Date(item["date"]).getTime();

          if (fromDate > itemDate|| tillDate < itemDate) {
            return false;
          }
        } else if (this.filters.date.model) {
          const [year, month, day] = this.filters.date.model.split("-");
          const date = `${day}/${month}/${year}`;
          if (item["dateCompare"] !== date) {
            return false;
          }
        }

        if (!item["date"]) {
            return false;
        }

        if (this.filters.month.model) {
          let month = this.filters.month.model;
          if (!(new Date(item["date"]).getMonth() == month)) {
            return false;
          }
        }

        if (this.filters.duration.model) {
          if (item["duration"] >= this.filters.duration.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.firms.model) {
          if (this.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (this.filters.gstType.model) {
          if (this.filters.gstType.model !== item["gstType"]) {
            return false;
          }
        }

        if (this.filters.paymentType.model) {
          if (item["paymentType"] === this.filters.paymentType.model) {
            return true;
          } else {
            return false;
          }
        }
        if (this.filters.invoiceStatus.model) {
          if (item["status"] === this.filters.invoiceStatus.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.invoiceNumber.model) {
          if (item[".key"] !== this.filters.invoiceNumber.model) {
            return false;
          }
        }

        if (this.filters.buyerName.model) {
          if (item["buyerId"] !== this.filters.buyerName.model) {
            return false;
          }
        }

        if (this.filters.gstPercentage.model) {
          if (
            !item.items.find(
              p => p["taxableGST_rate"] === this.filters.gstPercentage.model
            )
          ) {
            return false;
          }
        }

        if (this.filters.gstCategory.model) {
          if (
            !item.items.find(
              p => p["GST_type"] === this.filters.gstCategory.model
            )
          ) {
            return false;
          }
        }

        if (this.filters.isActive.model) {
          if (
            !item.items.find(
              p => p["isActive"] === this.filters.isActive.model
            )
          ) {
            return false;
          }
        }

        if (this.filters.hsnCode.model && item.items) {
          if (
            !item.items.find(p => p["HSN_code"] == this.filters.hsnCode.model)
          ) {
            return false;
          }
        }

        if (this.filters.unit.model) {
          if (
            !item.items.find(p => p["productUnit"] === this.filters.unit.model)
          ) {
            return false;
          }
        }

        if (this.filters.quantity.model) {
          if (
            item.items.find(p => p["quantity"] >= this.filters.quantity.model)
          ) {
            return true;
          } else {
            return false;
          }
        }

        return true;
      });
      this.selectProdList = [];
      filteredInvoices.map(invoice => {
        let invoiceMonth = new Date(invoice.date).getMonth();
        if (
          (!!this.filters.month.model
            ? invoiceMonth <= this.filters.month.model
            : true) &&
          !invoice.return &&
          Object.keys(productGroup).length
        ) {
          
          let isBuyer = invoice.isBuyer;
          invoice.items &&
            invoice.items.map(item => {
              if(productGroup[item["productId"]]) {
                 if (
                productGroup[item["productId"]][0].durationQuantity != undefined
              ) {
                let durationQuantity = Number.parseFloat(
                  productGroup[item["productId"]][0]["durationQuantity"]
                );
                durationQuantity += !!isBuyer
                  ? -Number.parseFloat(item.netWeight)
                  : Number.parseFloat(item.netWeight);
                total.durationQuantity += durationQuantity;
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = durationQuantity;
              } else {
                productGroup[item["productId"]][0][
                  "durationQuantity"
                ] = productGroup[item["productId"]][0].openingQuantity
                  ? productGroup[item["productId"]][0].openingQuantity
                  : 0;
                  total.durationQuantity += Number.parseFloat(productGroup[item["productId"]][0][
                  "durationQuantity"
                ]);
              }
              if(productGroup[item["productId"]][0].unitsDeatilsAdded) {
                let units = [...productGroup[item["productId"]][0].unitsDetails];
                units.sort((a, b) => parseFloat(a.order) - parseFloat(b.order));

                let isSelectedUnit = false;
                let multiplayer = 1;
                units.map(unit =>{
                  if(isSelectedUnit && parseInt(unit.quantity) >0) {
                    multiplayer = multiplayer*parseInt(unit.quantity);
                  }
                  if(unit.unit == item.unit) {
                    isSelectedUnit = true;
                  }
                })
                item.quantity = item.quantity * multiplayer;
              }
              let rate = (Number.parseFloat(item.rate));
              if(isBuyer) {
                if(invoice.date > latestSaleDate) {
                  latestSaleDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastSalePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['saleDetails'].push({
                  quantity : item.netWeight,
                  rate : rate,
                  date : invoice.date
                })
              } else {
                if(invoice.date > latestPurchaseDate) {
                  latestPurchaseDate = invoice.date;
                  productGroup[item["productId"]][0]['stockReportData']['lastPurchasePrice'] = rate;
                }
                productGroup[item["productId"]][0]['stockReportData']['purchaseDetails'].push({
                  quantity : item.netWeight,
                  rate : rate,
                  date : invoice.date
                })
              }
              productGroup[item["productId"]][0]["durationAmount"] += !!isBuyer
                ? -Number.parseFloat(item.basicPrice)
                : Number.parseFloat(item.basicPrice);
                total.durationAmount += productGroup[item["productId"]][0]["durationAmount"];
              if (!!isBuyer) {
                productGroup[item["productId"]][0][
                  "durationQtySale"
                ] += Number.parseFloat(item.netWeight);
                total.durationQtySale += Number.parseFloat(item.netWeight);
                productGroup[item["productId"]][0][
                  "durationAmountSale"
                ] += (Number.parseFloat(item.basicPrice));
                total.durationAmountSale += Number.parseFloat(item.basicPrice);
              } else {
                productGroup[item["productId"]][0][
                  "durationQtyPurchase"
                ] += Number.parseFloat(item.netWeight);
                total.durationQtyPurchase += Number.parseFloat(item.netWeight);
                productGroup[item["productId"]][0][
                  "durationAmountPurchase"
                ] += Number.parseFloat(item.basicPrice);
                total.durationAmountPurchase += Number.parseFloat(item.basicPrice);
              }
              item['date'] = invoice.date;
              item['invoice'] = invoice;
              item['isBuyer'] = invoice['isBuyer'];
              item['openingBalance'] = productGroup[item["productId"]][0]['openingBalance']
              item['openingQuantity'] = productGroup[item["productId"]][0]['openingQuantity']

    
              if(!(productGroup[item["productId"]][0]['productList'] && productGroup[item["productId"]][0]['productList'].length))
                { 
                  productGroup[item["productId"]][0]['productList'] = [];
                }
              productGroup[item["productId"]][0]['productList'].push(item)
              }
              
            });
        }
      });
      let results = [];
      let self = this;
      Object.keys(productGroup).length &&
        Object.keys(productGroup).map(function(key, index) {
          productGroup[key][".key"] = key;
          
            if(productGroup[key][0].unitsDeatilsAdded) {
              productGroup[key][0]['openingQuantityTitle']= self.getFilteredQuantity(productGroup[key][0],productGroup[key][0]['openingQuantity'])
              productGroup[key][0]['purchaseQuantityTitle']= self.getFilteredQuantity(productGroup[key][0],productGroup[key][0]['durationQtyPurchase'])
              productGroup[key][0]['saleQuantityTitle']= self.getFilteredQuantity(productGroup[key][0],productGroup[key][0]['durationQtySale'])
              productGroup[key][0]['closingQuantityTitle']= self.getFilteredQuantity(productGroup[key][0],((Number.parseFloat(productGroup[key][0]['openingQuantity']) + Number.parseFloat(productGroup[key][0]['durationQtyPurchase'])) -  Number.parseFloat(productGroup[key][0]['durationQtySale'])))
            }
          productGroup[key][0]['closingAmount'] = self.getClosingAmount(productGroup[key][0])
          // total.closingAmount += Number.parseFloat(productGroup[key][0]['closingAmount'])
          let closingStockVal = Number.parseFloat(productGroup[key][0]['closingAmount'])
          total.closingAmount += isNaN(closingStockVal) ? 0 : closingStockVal;
          productGroup[key][0]['closingQuantity'] = (Number.parseFloat(productGroup[key][0]['openingQuantity'] ?  productGroup[key][0]['openingQuantity'] : 0) + Number.parseFloat(productGroup[key][0]['durationQtyPurchase'] ?  productGroup[key][0]['durationQtyPurchase'] : 0)) - Number.parseFloat( productGroup[key][0]['durationQtySale'] ?  productGroup[key][0]['durationQtySale'] : 0)
          total.closingQuantity += isNaN(productGroup[key][0]['closingQuantity']) ? 0 : Number.parseFloat(productGroup[key][0]['closingQuantity']);
          results.push(productGroup[key][0]);
        });
        results.push({
            name : 'Total',
            ".key" : 'total',
            quantity : total.quantity,
            durationQuantity : total.durationQuantity,
            durationAmount : total.durationAmount,
            saleQuantity : total.saleQuantity,
            durationQtySale : total.durationQtySale,
            durationAmountSale : total.durationAmountSale,
            purchaseQuantity : total.purchaseQuantity,
            durationQtyPurchase : total.durationQtyPurchase,
            durationAmountPurchase : total.durationAmountPurchase,
            openingQuantity : total.openingQuantity,
            openingBalance : total.openingBalance,
            closingAmount : total.closingAmount,
            closingQuantity : total.closingQuantity,
          })
          results.map((prod,index) =>{
                  results[index]['quantity'] = Number.parseFloat(prod['quantity']).toFixed(3)
                  results[index]['durationQuantity'] = Number.parseFloat(prod['durationQuantity']).toFixed(3)
                  results[index]['durationAmount'] = Number.parseFloat(prod['durationAmount']).toFixed(3)
                  results[index]['saleQuantity'] = Number.parseFloat(prod['saleQuantity']).toFixed(3)
                  results[index]['durationQtySale'] = Number.parseFloat(prod['durationQtySale']).toFixed(3)
                  results[index]['durationAmountSale'] = Number.parseFloat(prod['durationAmountSale']).toFixed(3)
                  results[index]['purchaseQuantity'] = Number.parseFloat(prod['purchaseQuantity']).toFixed(3)
                  results[index]['durationQtyPurchase'] = Number.parseFloat(prod['durationQtyPurchase']).toFixed(3)
                  results[index]['durationAmountPurchase'] = Number.parseFloat(prod['durationAmountPurchase']).toFixed(3)
                  results[index]['openingQuantity'] = Number.parseFloat(prod['openingQuantity']).toFixed(3)
                  results[index]['openingBalance'] = Number.parseFloat(prod['openingBalance']).toFixed(3)
                  results[index]['closingAmount'] = Number.parseFloat(prod['closingAmount']).toFixed(3)
                  results[index]['closingQuantity'] = Number.parseFloat(prod['closingQuantity']).toFixed(3)
          })
      return results;
    },
    filteredGroups(){
      let products =  Object.assign([],this.filters.stockReportType.model == 'quantity' ? this.filteredProduct : this.filteredProductByWeight);
      let total = products.pop();
      let groups = JSON.parse(JSON.stringify(this.productGroups));
      groups.push({
        name : 'Non group Products',
        ".key" : 'Nongroup',
        quantity : 0,
        durationQuantity : 0,
        durationAmount : 0,
        saleQuantity : 0,
        durationQtySale : 0,
        durationAmountSale : 0,
        purchaseQuantity : 0,
        durationQtyPurchase : 0,
        durationAmountPurchase : 0,
        openingQuantity : 0,
        openingBalance : 0,
        closingAmount : 0,
        closingQuantity : 0
      })
      groups.map((item,index)=>{
        groups[index]['productList'] = [];
        groups[index]['quantity'] = 0;
        groups[index]['durationQuantity'] = 0;
        groups[index]['durationAmount'] = 0;
        groups[index]['saleQuantity'] = 0;
        groups[index]['durationQtySale'] = 0;
        groups[index]['durationAmountSale'] = 0;
        groups[index]['purchaseQuantity'] = 0;
        groups[index]['durationQtyPurchase'] = 0;
        groups[index]['durationAmountPurchase'] = 0;
        if(this.filters.stockReportType.model == 'weight' && item['.key'] != 'Nongroup') {
          groups[index]['openingQuantity'] = item.weight;
          groups[index]['openingBalance'] = item.openingBalance;
        } else {
          groups[index]['openingQuantity'] = 0;
          groups[index]['openingBalance'] = 0;
        }

        groups[index]['closingAmount'] = 0;
        groups[index]['closingQuantity'] = 0;
      })
      groups.map((item,index)=>{
        products.map((prod) =>{
          if(prod.productGroup && prod.productGroup == item['.key']) {
            groups[index]['productList'] = groups[index]['productList'].concat(prod.productList)
            groups[index]['quantity'] += Number.parseFloat(prod['quantity'])
            groups[index]['durationQuantity'] += Number.parseFloat(prod['durationQuantity'])
            groups[index]['durationAmount'] += Number.parseFloat(prod['durationAmount'])
            groups[index]['saleQuantity'] += Number.parseFloat(prod['saleQuantity'])
            groups[index]['durationQtySale'] += Number.parseFloat(prod['durationQtySale'])
            groups[index]['durationAmountSale'] += Number.parseFloat(prod['durationAmountSale'])
            groups[index]['purchaseQuantity'] += Number.parseFloat(prod['purchaseQuantity'])
            groups[index]['durationQtyPurchase'] += Number.parseFloat(prod['durationQtyPurchase'])
            groups[index]['durationAmountPurchase'] += Number.parseFloat(prod['durationAmountPurchase'])
            if(this.filters.stockReportType.model != 'weight') {
              groups[index]['openingQuantity'] += Number.parseFloat(prod['openingQuantity'])
              groups[index]['openingBalance'] += Number.parseFloat(prod['openingBalance'])
            }
            groups[index]['closingAmount'] += Number.parseFloat(prod['closingAmount'])
            groups[index]['closingQuantity'] += Number.parseFloat(prod['closingQuantity'])
          } else if(!prod.productGroup && item['.key'] == 'Nongroup') {
            groups[index]['productList'] = groups[index]['productList'].concat(prod.productList)
            groups[index]['quantity'] += Number.parseFloat(prod['quantity'])
            groups[index]['durationQuantity'] += Number.parseFloat(prod['durationQuantity'])
            groups[index]['durationAmount'] += Number.parseFloat(prod['durationAmount'])
            groups[index]['saleQuantity'] += Number.parseFloat(prod['saleQuantity'])
            groups[index]['durationQtySale'] += Number.parseFloat(prod['durationQtySale'])
            groups[index]['durationAmountSale'] += Number.parseFloat(prod['durationAmountSale'])
            groups[index]['purchaseQuantity'] += Number.parseFloat(prod['purchaseQuantity'])
            groups[index]['durationQtyPurchase'] += Number.parseFloat(prod['durationQtyPurchase'])
            groups[index]['durationAmountPurchase'] += Number.parseFloat(prod['durationAmountPurchase'])
            groups[index]['openingQuantity'] += Number.parseFloat(prod['openingQuantity'])
            groups[index]['openingBalance'] += Number.parseFloat(prod['openingBalance'])
            groups[index]['closingAmount'] += Number.parseFloat(prod['closingAmount'])
            groups[index]['closingQuantity'] += Number.parseFloat(prod['closingQuantity'])
          }
        })
      })
      groups.push(total);
      groups.map((prod,index) =>{
          groups[index]['closingAmount'] = (Number.parseFloat(prod['openingBalance']) + Number.parseFloat(prod['durationAmountPurchase'])) - (Number.parseFloat(prod['durationAmountSale']))
          groups[index]['closingQuantity'] = (Number.parseFloat(prod['openingQuantity']) + Number.parseFloat(prod['durationQtyPurchase'])) - (Number.parseFloat(prod['durationQtySale']))
      })
      if(this.filters.stockReportType.model == 'weight') {
              groups.map((prod,index) =>{
              groups[index]['quantity'] = Number.parseFloat(prod['quantity']).toFixed(3)
              groups[index]['durationQuantity'] = Number.parseFloat(prod['durationQuantity']).toFixed(3)
              groups[index]['durationAmount'] = Number.parseFloat(prod['durationAmount']).toFixed(3)
              groups[index]['saleQuantity'] = Number.parseFloat(prod['saleQuantity']).toFixed(3)
              groups[index]['durationQtySale'] = Number.parseFloat(prod['durationQtySale']).toFixed(3)
              groups[index]['durationAmountSale'] = Number.parseFloat(prod['durationAmountSale']).toFixed(3)
              groups[index]['purchaseQuantity'] = Number.parseFloat(prod['purchaseQuantity']).toFixed(3)
              groups[index]['durationQtyPurchase'] = Number.parseFloat(prod['durationQtyPurchase']).toFixed(3)
              groups[index]['durationAmountPurchase'] = Number.parseFloat(prod['durationAmountPurchase']).toFixed(3)
              groups[index]['openingQuantity'] = Number.parseFloat(prod['openingQuantity']).toFixed(3)
              groups[index]['openingBalance'] = Number.parseFloat(prod['openingBalance']).toFixed(3)
              groups[index]['closingAmount'] = Number.parseFloat(prod['closingAmount']).toFixed(3)
              groups[index]['closingQuantity'] = Number.parseFloat(prod['closingQuantity']).toFixed(3)
          })
      }

      return groups;
    },
    filteredInvoices() {
      return this.invoiceList.filter(item => {
        if (!Object.keys(this.filters).length) {
          return true;
        }

        if (!item.items || !item.items.length) {
          return false;
        }

        if (this.filters.tillDate.model && this.filters.date.model) {
          let fromDate = new Date(this.filters.date.model.split("-")).getTime();
          let tillDateTemp = new Date(
            this.filters.tillDate.model.split("-")
          )
          let tillDate = new Date(new Date(
           this.filters.tillDate.model.split("-")
          ).setDate(tillDateTemp.getDate() + 1)).getTime();
          let itemDate = new Date(item["date"]).getTime();

          if (!(fromDate < itemDate && tillDate > itemDate)) {
            return false;
          }
        } else if (this.filters.date.model) {
          const [year, month, day] = this.filters.date.model.split("-");
          const date = `${day}/${month}/${year}`;
          if (item["dateCompare"] !== date) {
            return false;
          }
        }

        if (this.filters.month.model) {
          if (!(new Date(item["date"]).getMonth() == this.filters.month.model)) {
            return false;
          }
        }

        if (this.filters.duration.model) {
          if (item["duration"] >= this.filters.duration.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.firms.model) {
          if (this.filters.firms.model !== item["firm"]) {
            return false;
          }
        }

        if (this.filters.gstType.model) {
          if (this.filters.gstType.model !== item["gstType"]) {
            return false;
          }
        }

        // if (this.filters.amount.model) {
        //   if (item["totalValue"] >= this.filters.amount.model) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }
        // if (this.filters.duration.model) {
        //   if (item["duration"] >= this.filters.duration.model) {
        //     return true;
        //   } else {
        //     return false;
        //   }
        // }

        // if (this.filters.rate.model) {
        //   if (this.filters.rate.model !== item["rate"]) {
        //     return false;
        //   }
        // }

        if (this.filters.paymentType.model) {
          if (item["paymentType"] === this.filters.paymentType.model) {
            return true;
          } else {
            return false;
          }
        }
        if (this.filters.invoiceStatus.model) {
          if (item["status"] === this.filters.invoiceStatus.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.invoiceNumber.model) {
          if (item[".key"] !== this.filters.invoiceNumber.model) {
            return false;
          }
        }

        if (this.filters.buyerName.model) {
          if (item["buyerId"] !== this.filters.buyerName.model) {
            return false;
          }
        }

        if (this.filters.gstPercentage.model) {
          if (
            !item.items.find(
              p => p["taxableGST_rate"] === this.filters.gstPercentage.model
            )
          ) {
            return false;
          }
        }

        if (this.filters.gstCategory.model) {
          if (
            !item.items.find(
              p => p["GST_type"] === this.filters.gstCategory.model
            )
          ) {
            return false;
          }
        }

        if (this.filters.isActive.model) {
          if (
            !item.items.find(
              p => p["isActive"] === this.filters.isActive.model
            )
          ) {
            return false;
          }
        }

        if (this.filters.hsnCode.model && item.items) {
          if (
            !item.items.find(p => p["HSN_code"] == this.filters.hsnCode.model)
          ) {
            return false;
          }
        }

        if (this.filters.unit.model) {
          if (
            !item.items.find(p => p["productUnit"] === this.filters.unit.model)
          ) {
            return false;
          }
        }

        if (this.filters.quantity.model) {
          if (
            item.items.find(p => p["quantity"] >= this.filters.quantity.model)
          ) {
            return true;
          } else {
            return false;
          }
        }
        
        if (this.filters.state.model) {
          if (item["state"] === this.filters.state.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.district.model) {
          if (item["district"] === this.filters.district.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.block.model) {
          if (item["block"] === this.filters.block.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.tehsil.model) {
          if (item["tehsil"] === this.filters.tehsil.model) {
            return true;
          } else {
            return false;
          }
        }

        if (this.filters.village.model) {
          if (item["village"] === this.filters.village.model) {
            return true;
          } else {
            return false;
          }
        }

        // if (this.filters.gstPercentage.model) {
        //   // if (item["buyerId"] !== this.filters.buyerName.model) {
        //   //   return false;
        //   // }
        // }
        return true;
      });
    }
  }
};
</script>

<style>
.search .theme--light.v-input:not(.v-input--is-disabled) input, .theme--light.v-input:not(.v-input--is-disabled) textarea {
    color: rgb(255, 255, 255);
}

.search .theme--light.v-label {
  color: rgb(255, 255, 255);
}
.search .theme--light.v-clearable {
  color: rgb(255, 255, 255);
}
.search {
  width: 50%;
  margin-left: 7%;
  margin-right: 7%;
}

.search .v-text-field > .v-input__control > .v-input__slot:after {
    border-color: white;

}

.search .theme--light.v-text-field > .v-input__control > .v-input__slot:before {
    border-color: white;
}
</style>


// WEBPACK FOOTER //
// src/components/Reports/GridView.vue